import axios from './api';

import { QUESTIONS_PER_PAGE } from './utilities/constants';
import { transformQuestionFolder } from './utilities/helpers';

/**
 * read question folder
 * @param {Object} options
 * @param {number} [options.folder]
 * @param {string} [options.folderTitle]
 * @param {string} [options.instantSurveyType]
 * @param {number} [options.limit]
 * @param {number} [options.offset]
 * @param {string} [options.ordering]
 * @param {string} [options.search]
 * @param {AbortSignal} options.signal
 * @return {Promise}
 */

export const readQuestionFolder = async ({
  folder,
  folderTitle: folder_title,
  instantSurveyType: instant_survey_type,
  limit = QUESTIONS_PER_PAGE,
  offset,
  ordering,
  search,
  signal,
}) => {
  return axios({
    method: 'get',
    params: { folder, folder_title, instant_survey_type, limit, offset, ordering, search },
    signal,
    url: '/instantsurvey/question_folder',
  }).then(({ data }) => transformQuestionFolder(data));
};
